import { Controller } from "@hotwired/stimulus"

// Umgebungswechsel der Shell (dmct.md #30, nur für Admins eingeblendet). Die Liste der Umgebungen kennt die Shell
// (window.configTool.environment.list()); gewechselt wird per Schlüssel, nie per URL. Die Shell speichert die Wahl
// und startet neu. Texte als Values aus der View (labels: Schlüssel -> Name).
export default class extends Controller {
  static targets = ["list", "status"]
  static values = { labels: Object, current: String, failed: String }

  async connect() {
    const environment = window.configTool?.environment
    if (!environment) return
    try {
      this.#render(await environment.list())
    } catch (error) {
      this.statusTarget.textContent = `${this.failedValue} ${error.message}`
    }
  }

  // data-config-tool--environment-key-param="staging"
  async switch({ params: { key } }) {
    this.listTarget.querySelectorAll("button").forEach((button) => (button.disabled = true))
    try {
      await window.configTool.environment.switch(key)
    } catch (error) {
      this.statusTarget.textContent = `${this.failedValue} ${error.message}`
      this.listTarget.querySelectorAll("button").forEach((button) => (button.disabled = button.dataset.current === "true"))
    }
  }

  #render(environments) {
    this.listTarget.replaceChildren(
      ...environments.map((env) => {
        const button = document.createElement("button")
        button.type = "button"
        button.className = "list-group-item list-group-item-action d-flex justify-content-between align-items-center"
        button.classList.toggle("active", env.current)
        button.disabled = env.current
        button.dataset.current = env.current
        button.dataset.action = "config-tool--environment#switch"
        // setAttribute statt dataset: aus camelCase entsteht nie das doppelte "--" des Stimulus-Identifiers.
        button.setAttribute("data-config-tool--environment-key-param", env.key)

        const label = document.createElement("span")
        label.textContent = this.labelsValue[env.key] ?? env.key
        const url = document.createElement("span")
        url.className = "small font-monospace"
        url.textContent = env.current ? `${env.url} · ${this.currentValue}` : env.url
        button.append(label, url)
        return button
      }),
    )
  }
}
